import { CoreUser } from 'fitify-types/src/types/core/user'

export const formatNumber = (number: number) => {
  return Intl.NumberFormat('en-US').format(number)
}

export const formatCurrency = (
  value: number,
  currency: string,
  locale: string
): string => {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
  }).format(value)
}

const DEFAULT_CURRENCY_FRACTION_DIGITS = 2

// ICU reports the CLDR display convention, not the minor unit a gateway bills in.
// Paddle charges COP and HUF in two-decimal form while ICU treats them as zero-decimal.
// https://developer.paddle.com/concepts/sell/supported-currencies
const isGatewayTwoDecimalCurrency = (
  currencyCode: string,
  gateway: CoreUser.Subscription.Gateway | undefined
): boolean => {
  switch (gateway) {
    case CoreUser.Subscription.Gateway.Paddle:
      return ['cop', 'huf'].includes(currencyCode.toLowerCase())
    default:
      return false
  }
}

export const getCurrencyFractionDigits = (
  currencyCode: string,
  gateway?: CoreUser.Subscription.Gateway
): number => {
  if (isGatewayTwoDecimalCurrency(currencyCode, gateway)) {
    return DEFAULT_CURRENCY_FRACTION_DIGITS
  }

  try {
    const { minimumFractionDigits } = new Intl.NumberFormat('en', {
      style: 'currency',
      currency: currencyCode,
    }).resolvedOptions()
    return minimumFractionDigits ?? DEFAULT_CURRENCY_FRACTION_DIGITS
  } catch {
    return DEFAULT_CURRENCY_FRACTION_DIGITS
  }
}

export const getCurrencyDenominator = (
  currencyCode: string,
  gateway?: CoreUser.Subscription.Gateway
): number => {
  return Math.pow(10, getCurrencyFractionDigits(currencyCode, gateway))
}
